

export function getAstronaut(): string {
    let candidate = ''
    do {
        candidate = generate()
    } while (forbidden.some(s => candidate.includes(s)))
    return `${candidate} Kerman`
}

function generate(): string {
    // mainline
    if (Math.random() < 0.2) return `${names[Math.floor(names.length * Math.random())]}`
    // wacky
    if (Math.random() < 0.2) {
        let n = [
            `${prefixes[Math.floor(prefixes.length * Math.random())]}${suffixes[Math.floor(suffixes.length * Math.random())]}`,
            `${prefixes[Math.floor(prefixes.length * Math.random())]}${suffixes[Math.floor(suffixes.length * Math.random())]}`,
        ]
        while (Math.random() > 0.3) {
            n.push(`${prefixes[Math.floor(prefixes.length * Math.random())]}${suffixes[Math.floor(suffixes.length * Math.random())]}`)
        }
        return n.join(' ')
    }
    // standard
    return `${prefixes[Math.floor(prefixes.length * Math.random())]}${suffixes[Math.floor(suffixes.length * Math.random())]}`
}

// https://github.com/jacob-swanson/kerbonaut-naming/blob/master/src/data.js
const names = [
    "Adam",
    "Al",
    "Alan",
    "Allison",
    "Archibald",
    "Benjamin",
    "Brian",
    "Buzz",
    "Carson",
    "Chad",
    "Charlie",
    "Chris",
    "Chrisnic",
    "Cristiano",
    "Chuck",
    "Dean",
    "Ed",
    "Edan",
    "Edlu",
    "Elliot",
    "Elon",
    "Fabien",
    "Felipe",
    "Felix",
    "Frank",
    "Franklin",
    "Gus",
    "Hans",
    "Hermes",
    "Jack",
    "James",
    "Jan",
    "Jaysef",
    "Jim",
    "Johan",
    "Kasper",
    "Kevin",
    "Kirk",
    "Kurt",
    "Lars",
    "Lashel",
    "Lefty",
    "Lem",
    "Luke",
    "Mac",
    "Malcolm",
    "Maldom",
    "Matt",
    "Mike",
    "Mind",
    "Minidou",
    "Pepe",
    "Peter",
    "Phil",
    "Pomeroy",
    "Randall",
    "Ruben",
    "Scott",
    "Sean",
    "Sido",
    "Spaghetti",
    "Steve",
    "Tim",
    "Tom",
    "Ted",
    "Vasya",
    "Will",
    "Ziggy",

    "Alice",
    "Barbara",
    "Bonnie",
    "Brooke",
    "Carol",
    "Ceri",
    "Dotty",
    "Dottie",
    "Eileen",
    "Ellen",
    "Gia",
    "Heidi",
    "Jane",
    "Jeaneane",
    "Jean",
    "Jeanette",
    "Joan",
    "Judith",
    "Karen",
    "Kazu",
    "Keema",
    "Leah",
    "Leia",
    "Lisa",
    "Lola",
    "Liz",
    "Maya",
    "Meg",
    "Mila",
    "Mae",
    "Maegan",
    "Margaret",
    "Mito",
    "Nancy",
    "Nina",
    "Marsha",
    "Megan",
    "Nicole",
    "Olivia",
    "Peggy",
    "Piper",
    "Phoebe",
    "Sally",
    "Samantha",
    "Sara",
    "Sarah",
    "Serena",
    "Shannon",
    "Summer",
    "Svetlana",
    "Stephanie",
    "Tamara",
    "Tati",
    "Tatiana",

    'Bill',
    'Bob',
    'Valentina',
    'Jebediah',
];

const prefixes = [
    "Ad",
    "Al",
    "Ald",
    "An",
    "Bar",
    "Bart",
    "Bil",
    "Billy-Bob",
    "Bob",
    "Bur",
    "Cal",
    "Cam",
    "Chad",
    "Cor",
    "Dan",
    "Der",
    "Des",
    "Dil",
    "Do",
    "Don",
    "Dood",
    "Du",
    "Dud",
    "Dun",
    "Ed",
    "El",
    "En",
    "Er",
    "Fer",
    "Fred",
    "Fro",
    "Gene",
    "Geof",
    "Ger",
    "Gil",
    "Greg",
    "Gus",
    "Had",
    "Hal",
    "Han",
    "Har",
    "Hen",
    "Her",
    "Hud",
    "Jed",
    "Jen",
    "Jer",
    "Joe",
    "John",
    "Jeb",
    "Jed",
    "Jon",
    "Jor",
    "Kel",
    "Ken",
    "Ker",
    "Kir",
    "Lan",
    "Lem",
    "Len",
    "Lo",
    "Lod",
    "Lu",
    "Lud",
    "Mac",
    "Mal",
    "Mat",
    "Mel",
    "Mer",
    "Mil",
    "Mit",
    "Mun",
    "Ned",
    "Neil",
    "Nel",
    "New",
    "Ob",
    "Or",
    "Pat",
    "Phil",
    "Pod",
    "Ray",
    "Rib",
    "Rich",
    "Ro",
    "Rod",
    "Ron",
    "Sam",
    "Sean",
    "See",
    "Shel",
    "Shep",
    "Sher",
    "Sid",
    "Sig",
    "Son",
    "Tan",
    "Ted",
    "Theo",
    "Thom",
    "Thomp",
    "Tom",
    "Wehr",
    "Wil",

    "Aga",
    "Al",
    "An",
    "Ar",
    "As",
    "Bea",
    "Bar",
    "Ber",
    "Car",
    "Cat",
    "Cer",
    "Clau",
    "Cris",
    "Da",
    "Daph",
    "De",
    "Deb",
    "Di",
    "Dan",
    "Eil",
    "Eli",
    "Eri",
    "Fran",
    "Gra",
    "Ger",
    "Gem",
    "Gi",
    "Gil",
    "Gle",
    "Gwen",
    "Hai",
    "Hay",
    "Hel",
    "Hil",
    "Isa",
    "Ir",
    "Ja",
    "Jan",
    "Jen",
    "Jes",
    "Jo",
    "Jul",
    "Ka",
    "Kar",
    "Kat",
    "Kath",
    "Ker",
    "Kim",
    "La",
    "Lager",
    "Le",
    "Lea",
    "Lee",
    "Lin",
    "Lis",
    "Liz",
    "Lu",
    "Ma",
    "Mad",
    "Mag",
    "Mar",
    "Mau",
    "Max",
    "Meg",
    "Mel",
    "Mi",
    "Mil",
    "Mir",
    "Mo",
    "Na",
    "Nata",
    "Ne",
    "Pa",
    "Pho",
    "Ra",
    "Ro",
    "Ros",
    "Sam",
    "San",
    "Si",
    "Sie",
    "Sig",
    "Sta",
    "Stel",
    "Su",
    "Tam",
    "Tan",
    "Te",
    "Ti",
    "Tra",
    "Tri",
    "Ur",
    "Val",
    "Ver",
    "Vir",
    "Wen",
    "Wil",
    "Zel"
]

const suffixes = [
    "ald",
    "bal",
    "bald",
    "bart",
    "bas",
    "berry",
    "bert",
    "bin",
    "ble",
    "bles",
    "bo",
    "bree",
    "brett",
    "bro",
    "bur",
    "burry",
    "bus",
    "by",
    "cal",
    "can",
    "cas",
    "cott",
    "dan",
    "dard",
    "das",
    "den",
    "din",
    "do",
    "dock",
    "don",
    "dorf",
    "dos",
    "dous",
    "dred",
    "drin",
    "dun",
    "ely",
    "emone",
    "emy",
    "eny",
    "fal",
    "fel",
    "fen",
    "field",
    "ford",
    "fred",
    "frey",
    "frid",
    "frod",
    "fry",
    "furt",
    "gan",
    "gar",
    "gard",
    "gas",
    "gee",
    "gel",
    "ger",
    "gun",
    "hat",
    "ing",
    "ke",
    "kin",
    "lan",
    "las",
    "ler",
    "ley",
    "lie",
    "lin",
    "lo",
    "lock",
    "long",
    "lorf",
    "ly",
    "mal",
    "man",
    "min",
    "ming",
    "mon",
    "more",
    "mund",
    "my",
    "nand",
    "nard",
    "ner",
    "ney",
    "nie",
    "ny",
    "oly",
    "ory",
    "pond",
    "pont",
    "rey",
    "rick",
    "rie",
    "righ",
    "rim",
    "rod",
    "ry",
    "sby",
    "sel",
    "sen",
    "sey",
    "ski",
    "son",
    "sted",
    "ster",
    "sy",
    "ton",
    "top",
    "trey",
    "uki",
    "ul",
    "us",
    "van",
    "vey",
    "vin",
    "vis",
    "well",
    "wig",
    "win",
    "wise",
    "zer",
    "zon",
    "zor",


    "alla",
    "anda",
    "anna",
    "anne",
    "ayne",
    "be",
    "bel",
    "belle",
    "bella",
    "bie",
    "beth",
    "berta",
    "by",
    "ca",
    "cee",
    "chel",
    "chell",
    "chelle",
    "cia",
    "cie",
    "cine",
    "cella",
    "cy",
    "da",
    "dra",
    "di",
    "dia",
    "die",
    "dine",
    "drien",
    "dolin",
    "edith",
    "elyn",
    "ella",
    "elle",
    "emma",
    "ena",
    "ene",
    "enna",
    "et",
    "ette",
    "gela",
    "gee",
    "gie",
    "grid",
    "gy",
    "i",
    "ice",
    "icca",
    "ie",
    "iel",
    "iella",
    "igh",
    "ina",
    "isa",
    "issa",
    "ise",
    "jorie",
    "ke",
    "la",
    "lee",
    "lenna",
    "liana",
    "lie",
    "lin",
    "lina",
    "line",
    "linne",
    "lian",
    "llian",
    "lotte",
    "ly",
    "lyn",
    "ma",
    "mie",
    "my",
    "na",
    "ne",
    "nica",
    "nie",
    "nne",
    "ny",
    "phe",
    "phie",
    "phia",
    "ra",
    "re",
    "ree",
    "rie",
    "righ",
    "rina",
    "rine",
    "ris",
    "ry",
    "rys",
    "sa",
    "san",
    "sei",
    "selle",
    "sie",
    "sy",
    "ta",
    "te",
    "tha",
    "this",
    "thy",
    "ti",
    "tina",
    "tine",
    "trice",
    "trid",
    "tris",
    "trix",
    "trude",
    "ty",
    "uki",
    "ula",
    "una",
    "vie",
    "vy",
    "xie",
    "xy",
    "y",
    "ya",
    "yin",
    "zie",
    "zy"
]

const forbidden = [
    "Dildo",
    "Kerbal",
    "Kerman",
    "eee",
    "rrr",
    "Orgee",
    "Dada",
    "Megma",
    "Anus",
    "Sambo",
    "aaa",
    "aae",
    "aai",
    "aay",
    "aie",
    "aea",
    "eae",
    "eai",
    "eei",
    "eea",
    "eei",
    "eey",
    "aee",
    "eaa",
    "iee",
    "iie",
    "aay",
    "eay",
    "aey",
    "aan",
    "uae",
    "uie",
    "uea",
    "uan",
    "uay",
    "lll",
    "nnn",
    "mmm"
]
